/**
 * Converts a Unix timestamp (in seconds or milliseconds) to a formatted date string.
 * @param timestamp - Unix timestamp (seconds or milliseconds).
 * @returns Date string in format: Fri Aug 29 2025 19:13:55
 */
const convertUnixToDate = (timestamp: number): string => {
  // Detect if timestamp is in seconds (10 digits) or milliseconds (13 digits)
  const date =
    timestamp.toString().length === 10
      ? new Date(timestamp * 1000) // seconds → ms
      : new Date(timestamp); // already ms

  // Remove timezone part
  return date.toString().split(' GMT')[0];
};

export default convertUnixToDate;
